"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var _react = _interopRequireDefault(require("react"));
var _BreadcrumbItem = require("./BreadcrumbItem");
var _Breadcrumbs = require("./Breadcrumbs.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$lightText = _ref.lightText,
    lightText = _ref$lightText === void 0 ? false : _ref$lightText,
    crumbs = _ref.crumbs,
    children = _ref.children,
    _ref$overlayColor = _ref.overlayColor,
    overlayColor = _ref$overlayColor === void 0 ? '#fff' : _ref$overlayColor,
    link = _ref.link,
    currentPage = _ref.currentPage;
  return /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Wrapper, {
    "aria-label": "Breadcrumb",
    "data-key": "max-breadcrumbs",
    overlayColor: overlayColor
  }, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Items, null, children, crumbs && crumbs.map(function (crumb, index) {
    return /*#__PURE__*/_react.default.createElement(_BreadcrumbItem.BreadcrumbItem, {
      lightText: lightText,
      key: "max-breadcrumbs__item-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Link, {
      lightText: lightText,
      as: link,
      to: crumb.url,
      dangerouslySetInnerHTML: {
        __html: crumb.label
      }
    }));
  }), currentPage && /*#__PURE__*/_react.default.createElement(_BreadcrumbItem.BreadcrumbItem, {
    lightText: lightText,
    key: "max-breadcrumbs__item-current"
  }, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Link, null, currentPage))));
};
exports.Breadcrumbs = Breadcrumbs;